module.exports = __webpack_public_path__ + "static/img/app-main-img02@m.f6f8414.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/app-main-img02@m.png
// module id = fhlG
// module chunks = 0